import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { endpoints } from './endpoints';
import type { Environment } from 'client-site-chrome-ui/environment';
import { getNewsletterSource } from 'client-site-chrome-ui/utils/getNewsletterSource';

const getUrl = (env: Environment) => `${endpoints[env].communicationPreference}`;

export const communicationPreferences = async (env: Environment, address: string) => {
  const status = 'ENABLED';
  const channel = 'email';
  const source = getNewsletterSource(window.location.pathname);
  const body = { address, channel, status, source };

  const fetchOptions = {
    method: 'POST',
    body,
  };

  try {
    const response = await fetchJSONWithTimeout(getUrl(env), fetchOptions);
    return response.ok;
  } catch (e) {
    const error = e as Error;

    return new Error(error.message);
  }
};
